import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { routes } from '../routes/routes';
import { AuthService } from './auth.service';

export function isFirebaseAuthenticatedGuard(): CanActivateFn {
  return async () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const user = await authService.getCurrentUser();

    if (user?.authenticated === 'firebase-only') {
      return true;
    }

    return router.navigate([routes.login.url()], { queryParamsHandling: 'merge' });
  };
}
